<template>
  <div :class="{'public-single-row-goods':!switchStyle , 'public-double-row-goods':switchStyle, 'checked-goods':canCheck, 'good-item': true}" :data-id="list.productId" :data-index="list.listIndex" :data-name="list.productFullName">
  <div class="check-container" v-if="canCheck">
       <common-checkbox v-model="list.isCheckedGood" :width="'18px'" :height="'18px'"></common-checkbox>
   </div>
  <div :class="{'goods-content':true,'hasCheck':canCheck}">
    <div class="left" @click="fnOpenGoodsDetail()">
      <div class="no-stock-mask" v-if="showNoStock"><img :src="`${$aliossUrl}/h5/ehaier/search_quehuo.png`" alt=""></div>
      <liveTag v-if="liveinfo.length && liveinfo[0].liveState==1" class="live-tag" size="small"/>
      <img :src="mainImage | imageToHttps | imageToWebp($webpSurpport)" alt />
      <div class="ng-presell-tag red-bg" v-if="isReservation"><span>预约</span></div>
      <div class="ng-presell-tag" v-else-if="isPreSell"><span>预售</span></div>
      <div class="rights-tag" v-if="list.optinalRightsFlag"><span>权益</span></div>
      <ActLabel v-if="list.firstImageInfo && list.firstImageInfo.firstImageType === 3" type="singleAndDoublePermutation" :firstImageInfo="list.firstImageInfo"/>
    </div>
    <div class="right" :class="{'has-no-stock': showNoStock}" @click="fnOpenGoodsDetail()">
      <div class="right_box">
        <!-- 商品名 -->
        <div class="name" :class="{'van-ellipsis':nameTitleOneLine}">
          <!-- <span class="title-labeltag" v-if="list.displayElementInfo && [20,30,40].includes(list.displayElementInfo.tagElementCode)" :class="{'labeltag-blue': list.displayElementInfo.tagElementCode == 40, 'labeltag-orange': list.displayElementInfo.tagElementCode == 20,'labeltag-hot': list.displayElementInfo.tagElementCode == 30}">{{ list.displayElementInfo.tagElementText }}</span> -->
          <template v-if="list.showTags && list.showTags.length > 0">
            <span v-for="tag in list.showTags" :key="tag" >
              <span v-if="tag == 'ZY'" class="title-labeltag" :class="{'labeltag-purple': tag == 'ZY'}">{{ tag == 'ZY' ? '自营' : '' }}</span>
            </span>
          </template>
          <template v-for="(tag, idx) in list.displayElementInfo">
            <span v-if="tag.tagElementCode != 10"  :key="idx" class="title-labeltag" :class="{'labeltag-blue': tag.tagElementCode == 40, 'labeltag-orange': tag.tagElementCode == 20,'labeltag-hot': tag.tagElementCode == 30, 'labeltag-brown': tag.tagElementCode == 60, 'labeltag-purple': tag.tagElementCode == 70}">{{ tag.tagElementText }}</span>
          </template>
          {{ list.productFullName }}
        </div>
        <!-- 副标题  （详情或活动) -->
        <!-- <div v-if="!switchStyle && !list.productAct && list.productTitle" :class="{'second':true, 'van-multi-ellipsis--l2':true,}">{{list.productTitle }}</div> -->
        <!-- 卖点 -->
        <div class="newDescribe">
          <ul v-if="list.sellPoint && (list?.attrs?.length != 3 || switchStyle)">
            <li v-for="(list,index) in list.sellPoint" :key="index">{{list}}</li>
          </ul>
        </div>
        <!-- 榜单 -->
         <template v-if="!switchStyle">
          <div class="item-brandlist" v-if="list.hotSellTag" @click.stop.prevent="goToTopPage(list.hotSellTag)"><span></span><strong>TOP{{ list.hotSellTag.listOrder }}</strong><p>{{ list.hotSellTag.listText }}</p><i></i></div>
        </template>
        <!-- 规格参数 -->
        <div class="specifications-item" v-if="!switchStyle && list?.attrs?.length == 3">
          <div class="specification-tab" v-for="(attr, aInd) in list.attrs" :key="aInd">
            <div>
              <strong>{{ attr.attrValue }}</strong>
              <span>{{ attr.attrName }}</span>
            </div>
            <span></span>
          </div>
        </div>
      </div>
      <!-- 价格 -->
      <div class="bottom">
        <div class="price-box">
          <div v-if='list.tradeInPriceInfo' class="trade-in-price">
            <p><small>￥</small><strong>{{  list.tradeInPriceInfo.tradeInPrice | formatPrice | formatPriceInt }}</strong><small>{{ list.tradeInPriceInfo.tradeInPrice | formatPrice | formatPriceFloat}}</small></p>
          </div>
          <div v-else class="price">
            <!-- <span class="discount" v-if="discountShow">
              <span class="discont-int"> {{internalDiscount | formatPrice | formatPriceInt}}</span>
              <span class="discont-float"> {{internalDiscount | formatPrice | formatPriceFloat}}</span>
              <span class="symbol">折</span>
            </span> -->
            <template v-if="$util.isPublicClient()">
              <template v-if="list.priceType === 70">
                <div class="flash-price">
                  <i></i>
                  <span><small>￥</small>{{(list.price || list.finalPrice) | formatPrice | formatPriceInt}}<small> {{(list.price || list.finalPrice) | formatPrice | formatPriceFloat}}</small></span>
                </div>
              </template>
              <template v-else>
                <span class="symbol">￥</span>
                <span class="price-int">
                  {{(list.price || list.finalPrice) | formatPrice | formatPriceInt}}
                </span>
                <span class="price-float">
                  {{(list.price || list.finalPrice) | formatPrice | formatPriceFloat}}
                </span>  
              </template>
            </template>
            <template v-else>
              <span class="symbol">￥</span>
              <span class="price-int">
                {{list.finalPrice | formatPrice | formatPriceInt}}
              </span>
              <span class="price-float">
                {{list.finalPrice | formatPrice | formatPriceFloat}}
              </span>
            </template>
            <!-- <span v-if="list.isLowestFlash" class="price-range">
              起
            </span> -->
            <div class="earnest" :class="{'earnest-client': $util.isPublicClient()}" v-if="list.priceType === 100"><span>订金</span></div>
            <div class="earnest" :class="{'earnest-client': $util.isPublicClient()}" v-if="!!list.clustersNum || list.groupBuy?.clustersNum"><span>{{list.clustersNum || list.groupBuy?.clustersNum}}人团{{ $util.isPublicClient() ? '购价': '' }}</span></div>
            <img v-else-if="list.priceType === 70 && !$util.isPublicClient()" class="price-img" src="//cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/huodongjia.png">
            <div class="activity-price" v-if="(list.priceType === 70 && !$util.isPublicClient()) || internalOriginPriceShow">
              <span class="tag">￥</span>
              <span class="price-left">
                {{list.defaultPrice | formatPrice}}
              </span>
              <!-- <span v-if="list.isLowestFlash" class="tag">
                起
              </span> -->
            </div>
            <div class="order-reudce" v-else-if="!!list.promotion">
              <span>下单立减{{list.promotion}}元</span>
            </div>
          </div> 
        </div>
        <!-- 库存 -->
        <!-- <div class="status" :class="{no: list.hasStock==='无货'}" v-if="list.hasStock">{{ list.hasStock }}</div> -->
      </div>
      <member-price
        style="margin-top: 0.08rem;"
        v-if="!!list.plusPrice"
        :memberPrice="list.plusPrice"
        :hasMinPrice="false"
      />
      <template v-for="(it, indx) in list.displayElementInfo">
        <p class="price-tips" v-if="it.tagElementCode == 10" :key="indx"><i></i>即将恢复原价</p>
      </template>
      <p v-if="list.tagElement == 10" class="price-tips"><i></i>即将恢复原价</p>
      <!-- <div v-if="list.priceType === 70 && (list.finalPrice > 10000) && switchStyle"  class="price-box price" style="display: flex; margin-left: .24rem">
        <img  class="price-img" src="//cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/huodongjia.png">
        <div class="activity-price">
          <span class="tag">￥</span>
          <span class="price-left">
            {{list.defaultPrice | formatPrice}}
          </span>
          <span v-if="list.isLowestFlash" class="tag">
            起
          </span>
        </div>
      </div>-->
      <!-- 佣金 -->
      <commission-label
        :storeId="visitStore"
        :mdCode="mdCode"
        class="commission-wrap"
        type='Permutation'
        :commissionType="list.commissionType"
        :theme="commissonlabelTheme"
        :list="list"/>
      <!-- 标签及优惠券标签，tags是在commonLoadItemNew接口中返回，marketingTagList和giftCoupon是在getPriceByProductList中返回-->
      <div class="goods-tag" v-if="(list.tags && list.tags.length) || (list.marketingTagList && list.marketingTagList.length) || list.giftCoupon || list.activityType == 100104">
        <ul>
          <!-- 礼品券Tag -->
          <li v-if="list.giftCoupon && list.giftCoupon.type === 'REALITY_GIFT_COUPON'">
            <!-- <SvgTag text="礼品券"/> -->
            <div class="svg-tag">礼品券</div>
          </li>
          <!-- 优惠券券Tag包含在marketingTagList里面 -->
          <li v-for="(item, index) in list.marketingTagList" :key="index">
            <div class="svg-tag">{{ item.text }}</div>
          </li>
          <!-- 商品标签，uadmin后台=>微店系统=>商品标签管理-->
          <li v-for="(item) in sortList(list.tags)" :key="item.id" style="display:none">
            <template v-if="item.tagType === 2">
              <SvgTag :text="item.tagName" :rectStrokeColor="item.tagFontColour" :rectFillColor="item.tagFontStyle === '1'?item.tagFontColour:'#ffffff'" :textFillColor="item.tagFontStyle == '1'?`#fff`:item.tagFontColour"/>
            </template>
            <template v-else>
              <img :src="item.tagUrl | imageToHttps | imageToWebp($webpSurpport)" alt />
            </template>
          </li>
          <li v-if="list.activityType==100104"><div class="svg-tag">凑单</div></li>
        </ul>
      </div>
      <!-- 评价 -->
      <div class="performance">
        <span class='ordered' v-if='alreadyBuy&&!switchStyle'>{{alreadyBuyText}}</span>
        <template v-if="list.recentCartNum || list.saleNum">
          <span v-if="list.recentCartNum">{{list.recentCartNum}}人加购</span>
          <span v-if="list.saleNum">{{list.saleNum}}人已买</span>
        </template>
        <template v-else>
          <span>{{(list.comments == '暂无评价' | !list.comments)?"暂无评价":list.comments+'条评价'}}</span>
          <span v-if="list.comments !== '暂无评价'&& list.comments">{{list.goodRate}}好评</span>
        </template>
      </div>
      <!-- 活动 -->
      <div v-if="list.productActNew" :class="{'second':true, 'van-multi-ellipsis--l2':true,'productActClass':true}">
        {{list.hasTag ? list.productActNew : (switchStyle ? (!!list.productActTerm ? ('活动日期：' + list.productActTerm) : '') : (list.productActNew + (!!list.productActTerm ? ('：' + list.productActTerm) : '')))}}
      </div>
      <div class='ordered' v-if='alreadyBuy&&switchStyle'>
        <span v-if='alreadyBuy&&switchStyle'>{{alreadyBuyText}}</span>
      </div>
      <!-- 榜单 -->
      <div class="doule-brandlist" v-if="switchStyle">
        <div class="item-brandlist" v-if="list.hotSellTag" @click.stop.prevent="goToTopPage(list.hotSellTag)"><span></span><strong>TOP{{ list.hotSellTag.listOrder }}</strong><p>{{ list.hotSellTag.listText }}</p><i></i></div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>

import liveTag from '@/components/liveTag'
import SvgTag from '@/components/singleAndDoublePermutation/components/svgTag.vue'
import memberPrice from '@/components/memberPrice'
import commonCheckbox from '@/components/checkbox/common-checkbox'
const commissionLabel = () => import('@/components/commissionLabel/index')
import ActLabel from "@/components/singleAndDoublePermutation/components/actLabel.vue";
import { PlatformTypes } from '@/config/constMaps'
/**
 * list 基础数据
 * switchStyle 切换商品独立排列样式，true=大图样式 false=单条样式
 */
export default {
  props: {
    liveinfo: {
      type: Array,
      default: () => []
    },
    list: {
      type: Object,
      default: () => {},
    },
    switchStyle: {
      type: Boolean,
      default: false
    },
    isFromSenceList: {
      type: Boolean,
      default: false
    },
    canCheck: {
      type: Boolean,
      default: false
    },
    visitStore: {
      type: String,
      default: '',
    },
    mdCode: {
      type: String,
      default: '',
    },
    shareId: {
      type: String,
      default: '',
    },
    taskId: {
      type: String,
      default: '',
    },
    stageId: {
      type: String,
      default: '',
    },
    cateName: {
      type: String,
      default: '',
    },
  },
  components: {
    liveTag,
    SvgTag,
    commonCheckbox,
    memberPrice,
    commissionLabel,
    ActLabel
  },
  computed: {
    showNoStock() {
      return (this.list.hasStock == '无货' || this.list.hasStock == 0) && !this.isPreSell && !this.isReservation
    },
    // 预约
    isReservation() {
      return this.list.showTags && this.list.showTags.length > 0 && this.list.showTags.includes('YY')
    },
    // 预售
    isPreSell() {
      return this.list.showTags && this.list.showTags.length > 0 && this.list.showTags.includes('YS')
    },
    commissonlabelTheme(){
      return sessionStorage.getItem('sg_home_open_scene') === 'PPHP' ? 'red' : ''
    },
    alreadyBuy() {
      return (this.list.signStoreFlag !== null) && (this.list.signStoreFlag !== undefined)
    },
    location() {
      return this.$store.getters['getlocationInfo']
    },
    internalDiscount() {
      let ret = 10
      if (this.list?.defaultPrice) {
        ret = (this.list?.finalPrice/(this.list?.defaultPrice))*10
      }
      return ret
    },
    discountShow() {
      return this.$util.isInternalChannel()
      // return this.$util.isInternalChannel() && (!this.list.defaultPrice || (this.list.defaultPrice && +this.list.finalPrice <= +this.list.defaultPrice))
    },
    alreadyBuyText() {
      if (this.visitStore && this.list.signStoreFlag) {
        return '本店买过的商品'
      }
      if (this.visitStore && this.list.signStoreFlag === false) {
        return '买过的商品'
      }
      if (!this.visitStore) {
        return '买过的商品'
      }
      return '';
    },
    nameTitleOneLine() {
      if (this.switchStyle) {
        return false;
      }
      return !(!this.list.productTitle && !this.list.productAct && !this.list.sellPoint);
    },
    internalOriginPriceShow() {
      // 内购环境下，商品列表页有划线价展示划线价，无划线价不展示，如果低于内购价格也不展示；
      let ret = false
      if(this.list.defaultPrice && this.list.defaultPrice > this.list.finalPrice && this.$util.isInternalChannel()){
        ret = true
      }
      return ret
    },
    /**
     * 主图展示逻辑
     * 主图来源有三个字段：defaultImageUrl、image、firstImageInfo
     * firstImageInfo 不存在：
     *     返回 defaultImageUrl || image
     * firstImageInfo 存在：
     *     firstImageInfo.firstImageType=1，活动图一定存在，返回活动图firstImageInfo.images[0]
     *     firstImageInfo.firstImageType=2，素材图一定存在，返回素材图firstImageInfo.images[0]
     *     
     */
    mainImage() {
      if (this.list?.firstImageInfo?.images.length && (this.list?.firstImageInfo?.firstImageType === 1 || this.list?.firstImageInfo?.firstImageType === 2)) {
        return this.list.firstImageInfo.images[0]
      } else {
        return (this.list.defaultImageUrl || this.list.image)
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    /**
     * 打开商品详情页面
     * productId id
     */
    fnOpenGoodsDetail() {
      let param = {
        productId: this.list.productId,
      }
      if (this.visitStore) {
        param.visitStore = this.visitStore
      }
      if (this.shareId) {
        param.shareId = this.shareId
      }
      if (this.list.skku) {
        param.skku = this.list.skku
      }
      if (this.list.comId) {
        param.comId = this.list.comId
      }
      if (this.list.caseId) {
        param.caseId = this.list.caseId
      }
      if (this.list.undertakeStore) {
        param.visitStore = this.list.undertakeStore
      }
      if (this.taskId) {
        param.taskId = this.taskId
      }
      if (this.stageId) {
        param.stageId = this.stageId
      }
      if(this.$util.isPublicClient() && this.list.storeId){
        param.visitStore = this.list.storeId
      }
      if (this.list.mdCode) {
        param.mdCode = this.list.mdCode
      } else if (this.mdCode) {
        param.mdCode = this.mdCode
      }
      if (this.$route.name === 'detail' || this.$route.name === 'detail2b') {
        param.trk_origin = 'spxq_cnxh'
      }
      if (this.$route.name === 'orderDetail') {
        param.trk_origin = 'ddxq_cnxh'
      }
      if (this.$route.name === 'orderList') {
        param.trk_origin = 'dd_cnxh'
      }
      if (this.$route.name === 'categoryList') {
        param.trk_origin = 'zhjd_pb'
      }
      if (this.$route.name === 'home') {
        this.$util.gioTrackWithVariable('MB13809', {
          user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
          member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
          roughly_classification_id: this.list.productCateId ? this.list.productCateId + '' : 'null',
          roughly_classification_name: this.cateName || 'null',
          productId_var: this.list.productId + '',
          site_number: ~~this.list.listIndex + 1 + '',
          productName_var: this.list.productFullName || 'null',
          province: this.location.province || 'null',
          city: this.location.city || 'null',
          county: this.location.district || 'null',
          street: this.location.township || 'null',
        })
      }
      if (this.$route.name === 'internalChannel') {
        this.$util.trackWithVariable({
          platformConf: {
            [PlatformTypes.INTERNAL_CHANNEL]: {
              id: 'IH20025',
              param: ['product_id', 'product_name', 'site_number']
            },
          },
        }, {
          product_id: this.list.productId + '',
          product_name: this.list.productFullName || 'null',
          site_number:  ~~this.list.listIndex + 1 + ''
        }).then(res => {
          console.log('report res', res)
        })
      }
      this.$util.gioTrackWithVariable('mall_proList_click_product', {
        productId_var: this.list.productId + ''
      })
      this.$emit('handleGoodClick', this.list)
      if(this.isFromSenceList){
        this.$router.push({
          path: '/smartSceneSearch',
          query: {
            sku: this.list.sku
          }
        })
      }else{
        this.$router.push({
          path: '/goodsDetail',
          query: param
        })
      }
    },

    goToTopPage(it){
      this.$router.push({
        path: '/smartProListTop',
        query: {
          cateId: it.hotSellCateId,
          subCateId: it.hotSellSubCateId,
        }
      })
    },

    sortList(arr) {
      if(!arr) return []
      let len = arr.length;
      for (var i = 0; i < len; i++) {
        for (var j = 0; j < len - 1 - i; j++) {
          if (arr[j].tagOrder > arr[j + 1].tagOrder) {
            var temp = arr[j + 1]
            arr[j + 1] = arr[j]
            arr[j] = temp
          }
        }
      }
      return arr
    },

  },
}
</script>

<style lang="scss" scoped>

// 大图模式
.public-double-row-goods{
  background-color: #fff;
  border-radius: 0.32rem;
  border-bottom: 0.01rem solid #eee;
  padding: 0 0 0.12rem 0;
  width: 3.36rem;
  // min-height: 5.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  // margin:0.16rem 0 0 0;
  @include synShadow;
  .left {
    position: relative;
    border-radius: .24rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    overflow: hidden;
    // z-index: 2;
    .live-tag{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
      border-bottom-left-radius: 0
    }    
    .ng-presell-tag{
      position: absolute;
      bottom: 0;
      width: 100%;
      z-index: 3;
      height: 18px;
      background-color: rgba(237, 40, 86 ,0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 11px;
      color: #FFFFFF;
    }
    .rights-tag{
      position: absolute;
      left: 0;
      top: 0;
      padding: 5px 8px 5px 9px;
      background-image: linear-gradient(90deg, #F4DFB4 2%, #E2C895 98%);
      border-radius: 8px 0 8px 0;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 10px;
      color: #886523;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 3.44rem;
      height: 3.44rem;
      border-top-left-radius: 0.16rem;
      border-top-right-radius: 0.16rem;
    }
  }
  .right {
    width: 100%;
    box-sizing: border-box;
    :deep(.member-price){
        margin-left: .24rem;
      }
    .commission-wrap{
      position: relative;
      left:0.22rem;
    }
    .right_box{
      padding: 0 0.24rem;
      line-height: 1.2;
      .newDescribe{
        padding: 0.12rem 0 0.06rem 0;
        /* max-height: 0.34rem; */
        overflow: hidden;
        /* margin-bottom: 8px; */
        ul{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          // height: 0.4rem;
          overflow: hidden;
          font-size: 0.2rem;
          li{
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow: hidden;
            color: #666666;
            margin-right: .08rem;
            margin-bottom: .08rem;
            background-color: #f6f6f6;
            border-radius: 2px;
            padding: 1px 4px;
            font-size: 0.2rem;
          }
          li:first-child{
            margin-left: 0;
          }
        }
      }
    }
    .name.van-ellipsis{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .name {
      max-height: 0.66rem;
      font-size: 0.28rem;
      color: rgba(51, 51, 51, 1);
      padding-top: 0.22rem;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      /* span {
        color: $themeSynMain;
        font-size: 0.2rem;
        border-radius: 0.18rem;
        line-height: 0.36rem;
        border: 0.01rem solid $themeSynMain;
        padding-left: 0.1rem;
        padding-right: 0.1rem;
        margin-right: 0.05rem;
        display: inline-block;
      } */
    }
    .second {
      padding-bottom: 0.16rem;
      font-size:.24rem;
      color:#999;
    }
    .productActClass{
      color: #FF5252;
      font-size: 0.22rem;
      word-break: break-all;
      font-weight: bold;
      padding: 0 0.24rem;
      margin-top: 0.16rem;
    }
    .flash-price{
      display: flex;
      align-items: center;
      width: 2.85rem;
      height: .44rem;
      background-image: linear-gradient(270deg, #FFF8F8 0%, #FFE4E4 100%);
      border-radius: 4px;
      font-size: .34rem;
      font-family: PingFangSC-Medium;
      i{
        display: inline-block;
        width: 1.02rem;
        height: .44rem;
        background: url(https://statics02.ehaier.com/h5/ehaier/common/flash_price_bg.png) no-repeat;
        background-size: contain;
      }
      small{
        font-size: .24rem;
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0 0 0.24rem;
      margin-bottom: 2px;
      .price-box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .price {
          font-size: 0.32rem;
          color: #ED2856;
          /* line-height: 0.35rem; */
          font-weight: bold;
          display: flex;
          align-items: baseline;
          flex-wrap: wrap;
          .discount{
            padding-left: 0.06rem;
            .discont-int{
              font-size: .36rem;
              margin-right: -.04rem;
            }
            .discont-float{
              font-size: .28rem;
            }
            .symbol{
              font-size: .28rem;
              margin-left: .04REM;
            }
          }
          .symbol{
            font-size: .2rem;
            font-weight: bold;
          }
          .z {
            display: flex;
            align-items: center;
            margin-left: 0.16rem;
            span {
              width: 0.28rem;
              height: 0.28rem;
              background: #ED2856;
              border-radius: 50%;
              font-size: 0.18rem;
              color: rgba(255, 255, 255, 1);
              line-height: 0.28rem;
              text-align: center;
            }
          }
        }
      }
      .status {
        color:$themeSynMain;
        font-size:.24rem;
        line-height:.28rem;
        padding-left: 0.14rem;
        padding-right: 0.24rem;
        height: 0.28rem;
        box-sizing: border-box;
      }
      .status.no {
        color:rgba(153,153,153,1);
      }
    }
  .goods-tag{
    padding: 0 0 0 0.24rem;
    margin:0 0.01rem 0 0.01rem;
    width: 2.9rem;
    overflow: auto;

    ul{
      margin-top: .01rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
     li{
        margin-right: 1px;
        display: inline-flex;
        align-items: center;
        padding-left: .02rem;
        img{
          // height:0.334rem;
          height:0.24rem;
        }

        span{
          height: 0.24rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          padding: 0 2px;
          color: #FF2E2E;
          border: 1px solid #FF2E2E;
          border-radius: 3px;
          box-sizing: border-box;
          small{
            margin-top: .04rem;
            font-size: .18rem;
          }
        }
        :deep(.van-tag--plain:before) {
          // height: 100%;
        }
      }
      li:last-child{
        margin-right:0;
      }
    }
  }
}
.price-tips{
  margin-left: .24rem;
}
  .performance{
    margin-top: .16rem;
    margin-bottom: .12rem;
    display: flex;
    color: #666;
    font-size: .2rem;
    line-height: .2rem;
    padding: 0 0.24rem;
    span{
      margin-right: 0.16rem;
    }

  }
  .ordered{
    line-height: 0.24rem;
    font-size: 0.2rem;
    padding: 0 0.24rem;
    margin-top: 0.12rem;
    margin-bottom: .08rem;
    
  }
  :deep(.van-tag) {
    border-radius: 0.08rem;
    font-size: 0.24rem;
  }
  :deep(.van-tag::after) {
    border-radius: 0.16rem;
    font-size: 0.24rem;
  }
}

.specifications-item{
  display: flex;
  align-items: center;
  .specification-tab{
    margin-bottom: .16rem;
    display: flex;
    align-items: center;
    > div{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      strong{
        margin-bottom: 2px;
        max-width: 1.2rem;
        text-align: center;
        @include text-overflow-single;
        font-size: .24rem;
        color: #333;
      }
      span{
        max-width: 1.2rem;
        text-align: center;
        @include text-overflow-single;
        font-size: .24rem;
        color: #999;
      }
    }
    
    &:last-child{
      padding-right: 0;
      margin-right: 0;
      border-right: none;
      >span{
        display: none;
      }
    }

    > span{
      margin: 0 .16rem;
      display: inline-block;
      height: .48rem;
      width: 1px;
      background-color: #ddd;
    }

    
  }
}

// 单排模式
.public-single-row-goods{
  min-height: 2.06rem;
  padding-top: 0.24rem;
  // padding-bottom: 0.24rem;
  display: flex;
  width: 100%;
  .left {
    position: relative;
    z-index: 2;
    border-radius: .24rem;
    overflow: hidden;
    height: 2.48rem;
    .live-tag{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      border-bottom-left-radius: 0
    }
    .ng-presell-tag{
      position: absolute;
      top: calc(2.48rem - 18px);
      width: 100%;
      z-index: 3;
      height: 18px;
      background-color: rgba(237, 40, 86 ,0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 11px;
      color: #FFFFFF;
    }
    .rights-tag{
      position: absolute;
      left: 0;
      top: 0;
      padding: 5px 8px 5px 9px;
      background-image: linear-gradient(90deg, #F4DFB4 2%, #E2C895 98%);
      border-radius: 12px 0 12px 0;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 10px;
      color: #886523;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 2.48rem;
      height: 2.48rem;
      border-radius: 0.24rem;
    }
  }
  .right {
    /* max-width: calc(100% - 3rem); */
    flex-grow: 1;
    box-sizing: border-box;
    margin-left: 0.24rem;
    padding-top: 0.1rem;
    // border-bottom: 0.02rem solid #eee;
    // padding-bottom: 0.22rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    :deep(.member-price){
      margin-left: 0;
    }
    .right_box{
      flex-grow: 1;
      width: 100%;
      // margin:0 0 0.12rem 0;
      .newDescribe{
        padding: 0.08rem 0 0 0;
        // transform: scale(0.75);
        // transform-origin: left;
        // width: 6.73rem;
        /* height: 0.34rem; */
        overflow: hidden;
        ul{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          /* height: 0.25rem; */
          overflow: hidden;
          font-size: 0.24rem;
          li{
            display: inline-flex;
            justify-content: center;
            align-items: center;
            margin-right: .08rem;
            margin-bottom: .08rem;
            padding:  1px 4px;
            /* border-left: 0.03rem solid #666666; */
            color:#666666;
            font-size: 0.2rem;
            background-color: #f5f5f5;
            border-radius: 2px;
          }
          li:first-child{
            border: none;
            margin-left: 0;
          }
        }
      }
    }
    .name {
      font-size: 0.28rem;
      color: rgba(51, 51, 51, 1);
      /* display: flex;
      align-items: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      p {
        display: inline-block;
      } */
      /* span {
        color: $themeSynMain;
        font-size: 0.2rem;
        border-radius: 0.18rem;
        line-height: 0.36rem;
        border: 0.01rem solid $themeSynMain;
        padding-left: 0.1rem;
        padding-right: 0.1rem;
        margin-right: 0.05rem;
        display: inline-block;
      } */
    }
    .second {
      margin: 0.08rem 0 0 0;
      font-size:.24rem;
      color:#999;
      min-height: 0.48rem;
      line-height: 1.5;
    }
    .productActClass{
      color: #FF5252;
      font-size: 0.22rem;
      word-break: break-all;
      font-weight: bold;
    }
    .flash-price{
      display: flex;
      align-items: center;
      width: 4rem;
      height: .44rem;
      background-image: linear-gradient(270deg, #FFF8F8 0%, #FFE4E4 100%);
      border-radius: 4px;
      font-size: .34rem;
      font-family: PingFangSC-Medium;
      i{
        display: inline-block;
        width: 1.02rem;
        height: .44rem;
        background: url(https://statics02.ehaier.com/h5/ehaier/common/flash_price_bg.png) no-repeat;
        background-size: contain;
      }
      small{
        font-size: .24rem;
      }
    }
    .bottom {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 2px;
      .price-box {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        .price {
          font-size: 0.32rem;
          color: #ED2856;
          font-weight: bold;
          .discount{
            padding-left: 0.06rem;
            .discont-int{
              font-size: .36rem;
              margin-right: -.04rem;
            }
            .discont-float{
              font-size: .28rem;
            }
            .symbol{
              font-size: .2rem;
              margin-left: .04REM;
            }
          }
          .symbol{
            font-size: .2rem;
            font-weight: bold;
          }
          .z {
            display: flex;
            align-items: center;
            margin-left: 0.16rem;
            span {
              width: 0.28rem;
              height: 0.28rem;
              background: #ED2856;
              border-radius: 50%;
              font-size: 0.18rem;
              color: rgba(255, 255, 255, 1);
              line-height: 0.28rem;
              text-align: center;
            }
          }
        }
      }
      .status {
        color:$themeSynMain;
        font-size:.24rem;
        line-height:.28rem;
        padding-left: 0.14rem;
        height: 0.28rem;
        box-sizing: border-box;
      }
      .status.no {
        color:rgba(153,153,153,1);
      }
    }
    .commission-wrap{
      position: relative;
      right:0.04rem;
    }
    .goods-tag{
      width: 4.09rem;
      overflow: hidden;
      margin:0 0.01rem 0 0.01rem;
      ul{
        margin-top: .01rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        li{
          margin-right: 1px;
          padding-left: .02rem;
          display: inline-flex;
          align-items: center;
          img{
            height:0.24rem;
          }
          span{
            height: 0.24rem;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            padding: 0 .02rem;
            color: #FF2E2E;
            border: 1px solid #FF2E2E;
            border-radius: 3px;
            box-sizing: border-box;
            small{
              margin-top: .04rem;
              font-size: .18rem;
            }

          }
        }
        li:last-child{
          margin-right:0;
        }
      }
    }
  }
  .performance{
    margin-bottom: .24rem;
    display: flex;
    color: #666;
    font-size: .2rem;
    line-height: .2rem;
    margin-top: 0.12rem;
    transform-origin: left;
    width: 4.09rem;
    text-wrap: nowrap;
    white-space: nowrap;
  
    span{
      margin-right: 0.16rem;
    }
  }
  :deep(.van-tag) {
    border-radius: 0.08rem;
    font-size: 0.24rem;
  }
  :deep(.van-tag::after) {
    border-radius: 0.16rem;
    font-size: 0.24rem;
  }
}

.title-labeltag{
  transform: scale(0.81);
  transform-origin: center;
  border-radius: 0.04rem;
  font-size: 0.22rem;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 0.24rem;
  font-weight: 500;
  width: 0.52rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  display: inline-block;
  position: relative;
  top: -0.02rem;
}

.labeltag-hot{
  background-image: linear-gradient(90deg, #FF70A5 0%, #F21247 100%);
}

.labeltag-blue{
  background-image: linear-gradient(90deg, #58B9FF 0%, #0F80EE 100%);
}

.labeltag-orange{
  background-image: linear-gradient(90deg, #F5A623 0%, #FF5500 100%);
}

.labeltag-brown{
  background-image: linear-gradient(90deg, #D5A44D 0%, #AA792F 100%);
}

.labeltag-purple{
  background-image: linear-gradient(90deg, #5A94FF 0%, #873AFC 100%);
}

.item-brandlist{
  margin-top: 4px;
  margin-bottom: .15rem;
  position: relative;
  display: inline-flex;
  max-width: 100%;
  box-sizing: border-box;
  height: .36rem;
  align-items: center;
  padding-left: .48rem;
  padding-right: .26rem;
  font-family: "PingFangSC", Helvetica, Arial, sans-serif;
  color: #BA5602;
  font-size: .2rem;
  background-image: linear-gradient(269deg, rgba(255,177,118,0.20) 0%, rgba(255,105,13,0.20) 100%);
  border-radius: 4px;
  overflow: hidden;
  transform: translateZ(0);
  will-change: auto;
  span{
    position: absolute;
    left: 0;
    top: 0;
    width: .44rem;
    height: .36rem;
    background: url(data:image/png;base64,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) no-repeat;
    background-size: contain;
    transform: translateZ(0);
    will-change: auto;
  }
  i{
    position: absolute;
    right: .05rem;
    top: .05rem;
    width: .24rem;
    height: .24rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAABg0lEQVRYCe3XsU7DMBAA0Lu4GSJ+gE+oxMQAeyFlRBWoCSMfwMDC3pmFX2ACQiUkGEmkfgASSwHxCfABVYfSHr4KLyhpI/u8xcvJVux7vboXFaAZTQWaCgDQfV8VabjDUboeaHNgnqhHAjoEhPcwiuLO9eTL5pyyPUHZ4to1pPbyGYKt2XQ6Gp1ubK7dU/MBKxAhXujS/vyh2pIoK9DB3fwJEFMfKKs7ZKqfp+oIiDICaC3XED71neq43CknECOkUc4gaZQISBIlBpJCiYIkUOIgV5RVH+Kkq0Y3mz+U9KmizrvPS4UMNk9bV0SLczMPUO3G2ezFzMuilwpxoudU9YEWZyap/uTj/ePeq5lXRS8gxiDRjengGvOBKupiMpxXQcy6+FdWgdmLbyffJumqKApyxTBUDCSBEQNJYURAkhhnkDTGCeQDYw0qEtXT/zqG//pM7Z82J64aVo2RkC59YBhpByJ84826Z4x1BxapDJ9nPWgwCPKTcJuj9SHNxqYCnirwC7VV4wn3MVVbAAAAAElFTkSuQmCC) no-repeat;
    background-size: contain;
    transform: translateZ(0);
    will-change: auto;
  }
  strong{
    /* font-family: DINAlternate-Bold; */
    margin: 0 2px;
    font-size: .2rem;
    font-weight: 500;
    transform: translateZ(0);
    will-change: auto;
    font-family: PingFangSC-Medium;
  }
  p{
    flex: 1;
    max-width: 100%;
    /* @include text-overflow(1); */
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transform: translateZ(0);
    will-change: auto;
    font-family: "PingFangSC", Helvetica, Arial, sans-serif;
  }
}


.svg-tag{
  margin-bottom: 2px;
  padding: 1px 2px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ED2856;
  color: #ED2856;
  font-size: .18rem;
  border-radius: 2px;
}

.ordered{
  color:#EB8F02;
}
.price{
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  /* font-weight: bold; */
  position: relative;
  /* left: -.06rem; */
  font-family: PingFangSC-Medium;;
}
.price .price-int{
  position: relative;
  left: -.02rem;
  font-size: 0.32rem;
  font-weight: normal;
}
.price .price-float{
  position: relative;
  left: -.04rem;
  font-size: 0.2rem;
  font-weight: normal;
  white-space: nowrap;
}
.price .price-range{
  position: relative;
  left: -.06rem;
  font-size: 0.2rem;
  margin-right: -.1rem;
  font-weight: bold;
  display: inline-block;
  transform: scale(.83);
}
.price .price-img{
  position: relative;
  top: .04rem;
  width:0.66rem;
  height: 0.24rem;
}
.public-single-row-goods{
  justify-content: flex-start;
  .check-container{
    // width: .84rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: .32rem;
  }
  .goods-content{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .right{
      width: 4.1rem;
      .right_box{
          width: 4.1rem;
      }
    }
  }
  .goods-content.hasCheck{
    width: calc(100% - 1.16rem);
    .right_box{
      width: 3.4rem;
    }
  }
}

.public-double-row-goods {
  .check-container{
    position: absolute;
    right: .16rem;
    top: .16rem;
    z-index: 5;
  }
  .goods-content{
     width: 100%;
       .right{
          width: 100%;
              .right_box{
                // width: 100%;
              }
            }
  }
}
.public-double-row-goods.checked-goods{
  position: relative;
}

.has-no-stock{
  opacity: .4;
}
.no-stock-mask{
  display: flex;
  justify-content: center;
  align-items: center;;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,.3);
  z-index: 2;
  border-radius: .24rem;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  > img{
    width: 1.44rem !important;
    height: 1.44rem !important;
  }
}

.price-tag{
  width: 0.7rem;
  height: .4rem;
  opacity: 1;
  background: linear-gradient(90deg,#ff2b2b 13%, #ff7f25 83%);
  border-radius: 0.06rem;
  font-size:12px;
  color:#fff;
  text-align: center;
  line-height:.4rem;
  transform: scale(.8);
}
.activity-price {
  display: flex;
  height: .24rem;
  font-size: .2rem;
  font-weight: bold;
  color: #999;
  margin-left: .06rem;
  text-decoration: line-through;
  align-items: baseline;
  .tag {
    margin-left: -.03rem;
    font-size: .24rem;
    display: inline-block;
    transform: scale(.75);
    text-decoration: line-through;
  }
  .price-left {
    margin-left: -.06rem;
    font-size: .24rem;
  }
}
.order-reudce {
  height: 0.26rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  background: linear-gradient(90deg,#ff6f1d 13%, #fe4e4e 83%);
  border-radius: 0.06rem;
  transform: translateY(-0.04rem);
  span {
    color: white;
    font-size: .24rem;
    display: inline-block;
    transform: scale(.83);
    margin: 0 -.08rem;
  }
}

.price-tips{
  display: inline-flex;
  align-items: center;
  padding: 3px 0;
  padding-bottom: 5px;
  font-family: PingFangSC-Regular;
  font-size: .22rem;
  color: #ED2856;
  i{
    margin-right: 2px;
    display: inline-block;
    width: .24rem;
    height: .24rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAAEbUlEQVRYCc1Yz29TRxCeWRsSqNLGtgTCEj0ihV+qRE9pI06c2ghQaGJaIfEPFFohcaAHOEAPlaK2wB+AhAR2UAQHEAdzo82Nih8Bo56qIqUSwjYoakmIvct8+7zrZydOXhI7zUr2zu7Ozve93X2zM49pmeX1nq8Tumq+IKMPkKGPDVOayMgPhafY0BQx/U2s8irGd3qfXCsHY9H+OZoaUbkvc9gY8y2xGTCG4lHmMVOFDN9n5kuJQvZmpDlLKZV2DX9GVf7JkOlfSnexcSaeoJg5nXw69vviei1GzVdjsdLk+CgZczKsIoa1rNKEbNUtpdSDWMVM9cRSU9CZrhbT1Tintdb7ZOsOyer0y4Oo8Hxi/jW5e+gU3xiuNvTXGgtuWfmT47169r8xOSMH6pN4Rrbg4oYNG0d7Hl99We9vLU3vPbZlbu7dKdniE3LOur0mU151bR5OPLzy2vfVhHmEAjJvJ2Rl+urKPE5x/j41mX1R74suFXdntlPF/Cykhvws5oLq2tTfTKphObFNwcoEZIStYaV+SD3PHVkpGRDAXNiALdi0pOSBgQVMT1KEhhUq9o384s4MJgqbo6lCNhee0CzLoR8kTYMUi11OTl5/3Dze3C72ZUbY6OvCKsCWM5Uq5L5zep4Q3iZTpd/8gDxN8ln2R9deqDZ7j31QnpstyRnZKK/2H8lCbt9Ces19pZ2ZM0brC66fY/S5e/vqWyavtlMQ8uNLkYHuW+ZekIEsPmor6iglsC3n0pUQtiVknZ73MzyDA+x0O1ZbDMGSAh8HDpAtIeuB0ZKCV3s1BziwsvQ/MIDlNB0HhbsJ1wEG4PTgZ5xSp2tgWUdrwc0AuChT0V/6u0k8cFSn1w6yFkswYQscwEXJ/nlvjOugHUDLsRHGBBclJ2q7M4C7yclrVTdgCpe4jWcC30m4KFdB5MPizsy5VvNZmxnu5mziYfavsA4wda0DXCSuccEVkbu1wxOWIfeQ1mdb6dtnnqVvZHxPWAeYpeqrWpdJY8tq6yN9vTPec4cntZI3pT96JRPetBqP1B/GFC5xcTz/yBHvweTp4r/bUEUyJEp899JsedfIftmOQc1q0SjSblkXZ5tt1zCDbuESRwwsS7QDPQiupPozGI32n3iaeySa+K2oWMxKsEngomxAXjOFSG9FVlcxSWv61E+X5ECJp7znOmzY6RprVEsoctBDIVPhuLptswP0SgyMsNMrdFiwWIIJGHBA2qRs3iSpCjrlkCvEwJDXoth42yUBwgFc7G2PvMkRkDvlhI2BXUeHamAAy5l3HCwhJHFyluwlJ+vUHQTkTrVDdRD020wE2C6RtIQspCRxdWgzhDCz3m6vFNgOZSAhbE/IxrQScHtorc8jIPftNgnWptj25pA4hrJZTwgKyCjFL+Uhi6tiZAftXCnYasw4KG8xAVgr8+6u/ztRnEcIRNdVKu2Wbl19bHCkUK+bzzFhUpDXzQerZmJIVWymguRAYmAbAvuo03/SeyHOLo97crmf9N4DOk8xvI181PUAAAAASUVORK5CYII=) no-repeat;
    background-size: contain;
  }
}

.earnest {
  position: relative;
  top: -3px;
  margin-left: 2px;
  font-size: 0;
  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 2px;
    background: linear-gradient(90deg,#ff2b2b 13%, #ff7f25 83%);
    border-radius: 2px;
    color: white;
    font-size: .2rem;
  }
}
.earnest-client{
  top: -1px;
  color: #ED2856;
  span{
    background: none;
    color: #ED2856;
  }
}
.trade-in-price {
  // margin-top: .16rem;
  margin-bottom: 4px;
  width: 2.6rem;
  height: .4rem;
  padding-left: .8rem;
  background: url(https://statics02.ehaier.com/h5/ehaier/renewed_pricebg.png) no-repeat;
  background-size: contain;
  color: #2D77FC;
  p{
    /* display: flex;
    justify-content: flex-start;
    align-items: baseline; */
    line-height: .4rem;
    width: 1.6rem;
    justify-content: center;
  }
  small{
    font-family: PingFangSC-Medium;
    font-size: .2rem;
    &:first-child{
      font-size: .16rem;
    }
  }
  strong{
    font-family: PingFangSC-Medium;
    font-size: .32rem;
  }
}

.doule-brandlist{
  margin-top: 2px;
  padding: 0 .24rem;
  .item-brandlist{
    margin: 0;
    margin-bottom: .1rem;
  } 
}
</style>
